@if (label(); as l) {
  <div class="my-2 inline-block font-heading text-sm font-medium text-neutral-100 xs:text-base">
    {{ l }}
    @if (ngControl.control?.hasValidator(Validators.required)) {
      <span class="px-1 text-negative-150">*</span>
    }
  </div>
}
<div id="input-element" class="pointer-events-non relative flex w-full flex-col font-sans">
  <input
    #inputElement
    [attr.type]="_type()"
    (input)="onChange(value)"
    [(ngModel)]="value"
    [attr.aria-labelledby]="'label-' + name()"
    [disabled]="_disabled()"
    [id]="name()"
    [name]="name()"
    (focusout)="setPending()"
    (focus)="setSelectionRange(inputElement)"
    oninput="classList[value ? 'add' : 'remove']('has-content')"
    [ngClass]="[ringClass, internalLabel() ? 'pb-0.5 pt-5' : 'py-3', value ? 'has-content' : '', textOffset()]"
    [placeholder]="placeholder()"
    class="disabled:color-neutral-20 keeper-ignore peer w-full appearance-none overflow-hidden px-4 outline-none placeholder:text-neutral-40 focus:border-0 disabled:border-neutral-20 disabled:bg-neutral-5 disabled:text-neutral-20"
    [type]="type()"
    [autocomplete]="autoComplete()"
    [maxlength]="maxLength() ?? null" />

  @if (maxLength(); as maxLen) {
    <label for="{{ name() }}" class="keeper-ignore text-md pointer-events-none absolute right-1 top-3 px-4 text-neutral-40">
      {{ value.length }}
      / {{ maxLen }}
    </label>
  }

  @if (internalLabel(); as iLabel) {
    <label
      [ngClass]="[ngControl.touched && ngControl.invalid && validationLevel() > 1 ? 'text-negative-100' : 'text-neutral-40']"
      for="{{ name() }}"
      class="peer-[&:not(:focus):not(.has-content)]:text-md pointer-events-none absolute px-4 transition-all duration-200 ease-in-out peer-focus:top-1 peer-focus:text-xxs peer-[&:not(:focus):not(.has-content)]:top-1/2 peer-[.has-content]:top-1 peer-[&:not(:focus):not(.has-content)]:-translate-y-1/2 peer-[.has-content]:text-xxs">
      {{ iLabel | translate }}
    </label>
  }

  @if (showPasswordSvg()) {
    <button
      type="button"
      tabindex="-1"
      class="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-neutral-60 hover:cursor-pointer hover:text-primary-100"
      (click)="togglePasswordVisibility()">
      <pay-icon [shape]="showPassword ? IconNames.ViewOffFilled : IconNames.ViewFilled" size="md" />
    </button>
  }
</div>

@if (helperText(); as hText) {
  <div class="my-2 text-xs text-neutral-80 sm:px-2" id="hint-phoneNumber">
    {{ hText }}
  </div>
}

@if (!overrideValidation()) {
  <pay-field-multi-validator [ngControl]="[ngControl]" [pendingObs]="pendingSubject.asObservable()" />
}
